import React, { useEffect, useState } from "react";
import { TextField, Box, Button, Typography, Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { otpApi } from "./otpApi";
import { generateRandomString, getSession } from "../../utils/commonUtils";
import { encrypt } from "../../utils/encryption";
import { routePath } from "../../constants/routePath";
import { useSelector } from "react-redux";
import { VALIDCUSTOMERAPPOINMENTANAMONUS, VALIDOTP } from "../../utils/api";
import ElegantLogo from "../../assets/elegantPrimeLogo.png";

const OTP = () => {
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [error, setError] = useState("");
  const customerAppointmentId = useSelector(
    (state) => state.reducer.customerAppointmentId,
  );
  const apppoinmentUerType = useSelector(
    (state) => state.reducer.apppoinmentUerType,
  );
  const navigate = useNavigate();

  const handleChange = (value, index) => {
    let newOtp = [...otp];
    if (/^[0-9]?$/.test(value)) {
      newOtp[index] = value;
      setOtp(newOtp);
    }
  };

  const handleKeyUp = (e, index) => {
    const nextInput = document.querySelector(`input[name=otp${index + 1}]`);
    const prevInput = document.querySelector(`input[name=otp${index - 1}]`);

    if (e.key === "Backspace" && !otp[index] && prevInput) {
      prevInput.focus();
    } else if (nextInput && e.target.value !== "") {
      nextInput.focus();
    }
  };

  const payLoadhandle = (obj) => {
    const randomId = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, "0");
    const pass = otp.join("");

    console.log('random', randomId)
    if (apppoinmentUerType === "otp") {
      return {
        api: VALIDCUSTOMERAPPOINMENTANAMONUS,
        payload: {
          customerAppointmentId,
          otp: pass,
        },
      };
    } else {
      let passt = pass + randomId;
      return {
        api: VALIDOTP,
        payload: {
          guid: obj.guId,
          otp: encrypt(passt, "9z8x7c1m2n3b5l4k"),
        },
      };
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");

    if (enteredOtp.length < 4 || otp.includes("")) {
      setError("Please enter all 4 digits.");
      return;
    }

    setError(""); // Clear any previous error
    getSession("eleGentUser", (data) => {
      const obj = JSON.parse(data);
      const payload = payLoadhandle(obj);

      otpApi(payload, (res) => {
        if (res?.succeeded === true) {
          navigate(routePath.SETMPIN);
        } else {
          setError("Invalid OTP. Please try again.");
        }
      });
    });
  };

  return (
    <Box
      sx={{
        mt: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: "1200px",
          height: "70vh",
          background: "linear-gradient(to right, #dad4f0, #00008B)",
          display: "flex",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: 5,
        }}
      >
        {/* Left: Logo */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={6}>
              <img
                src={ElegantLogo}
                alt="Elegant Logo"
                style={{ width: "350px" }}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Right: OTP Form */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              backgroundColor: "#fff",
              padding: 4,
              borderRadius: "16px",
              width: "100%",
              maxWidth: "360px",
              boxShadow: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                mb: 2,
                color: "#01008B",
                textAlign: "center",
                fontSize: 26,
              }}
            >
              OTP VERIFICATION
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mb: 3,
                px: 2,
                fontSize: 16,
                fontWeight: 500,
                color: "#01008B",
              }}
            >
              Enter OTP
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 2,
                px: 3,
              }}
            >
              {otp.map((value, index) => (
                <TextField
                  key={index}
                  name={`otp${index}`}
                  value={value}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyUp={(e) => handleKeyUp(e, index)}
                  variant="standard"
                  inputProps={{
                    maxLength: 1,
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      fontSize: "24px",
                      width: "60px",
                      height: "60px",
                    },
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomWidth: "3px",
                      borderColor: "#01008B",
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomWidth: "3px",
                      borderColor: "#01008B",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomWidth: "3px",
                      borderColor: "#01008B",
                    },
                  }}
                />
              ))}
            </Box>

            {error && (
              <Typography
                sx={{ color: "red", fontSize: 14, textAlign: "center", mb: 2 }}
              >
                {error}
              </Typography>
            )}

            <Button
              variant="contained"
              type="submit"
              fullWidth
              sx={{
                backgroundColor: "#01008B",
                color: "#fff",
                fontWeight: "500",
                textTransform: "none",
                fontSize: "18px",
                py: 1,
                mb: 2,
                borderRadius: "4px",
              }}
            >
              Continue
            </Button>

            <Typography
              variant="body2"
              sx={{
                color: "#333",
                textAlign: "center",
                fontSize: 18,
                color: "#01008B",
              }}
            >
              OTP Not Received?{" "}
              <Link
                to="#"
                style={{
                  color: "#01008B",
                  fontWeight: "600",
                  textDecoration: "none",
                }}
              >
                <br />
                Resend
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OTP;
